module.exports = __webpack_public_path__ + "9570aa2682bae4843de4c86c85a0255d.jpg";